import type {
  MobileBookingAvailabilityGetApiData,
  MobileBookingAvailabilityGetApiResponses,
  StationaryGaragesListApiData,
  StationaryGaragesListApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint } from '../defineResource';

export const bookingChoiceUrls = {
  getMobileBookingAvailability: dataEndpoint<
    MobileBookingAvailabilityGetApiData,
    MobileBookingAvailabilityGetApiResponses
  >({
    getUrl: (queryParams) => apiUrl('bookings/mobile-availability/', queryParams)
  }),
  getStationaryGarages: dataEndpoint<StationaryGaragesListApiData, StationaryGaragesListApiResponses>({
    getUrl: (queryParams) => apiUrl('bookings/stationary-garages/', queryParams)
  })
};
